import { UnleashClient } from '@unleash/proxy-client-vue'

import { config } from '@/lib/helpers'

const unleashConfig = {
  url: config.unleash.proxyUrl,
  clientKey: config.unleash.clientKey,
  refreshInterval: 120,
  appName: 'admin-app-v2',
  disableMetrics: true,
  environment: config.environment,
}

export const unleashClient = new UnleashClient(unleashConfig)

let flagsReady = false

unleashClient.on('ready', () => {
  flagsReady = true
})

export const waitForFlagsReady = (timeoutMs = 3000): Promise<void> => {
  if (flagsReady) {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    const cleanup = () => {
      clearTimeout(timer)
      unleashClient.off('ready', onReady)
    }
    const onReady = () => {
      cleanup()
      resolve()
    }
    const timer = setTimeout(() => {
      cleanup()
      resolve()
    }, timeoutMs)
    unleashClient.on('ready', onReady)
  })
}
